/**
 * Shared chat session key helper.
 * Used by both PageTracker (analytics) and ChatWidget (live chat)
 * to guarantee a consistent session key across both systems.
 *
 * Strategy:
 *  1. Return existing `rex-chat-session` from localStorage if present.
 *  2. Otherwise generate a new UUID, persist it, and return it.
 *  3. If localStorage is unavailable (bots, restricted environments),
 *     fall back to the per-tab `_pv_sid` session ID so pageviews still
 *     carry a non-null key (though proactive chat won't work for these).
 */

const STORAGE_KEY = "rex-chat-session";

export function getOrCreateChatSessionKey(): string {
  try {
    let key = localStorage.getItem(STORAGE_KEY);
    if (!key) {
      key = crypto.randomUUID();
      localStorage.setItem(STORAGE_KEY, key);
    }
    return key;
  } catch {
    // localStorage blocked – fall back to session-scoped tracking ID
    try {
      return sessionStorage.getItem("_pv_sid") || crypto.randomUUID();
    } catch {
      return crypto.randomUUID();
    }
  }
}
